<script setup>
import { useRoute } from "vue-router";
import ILogout from "@/assets/img/icon/i-logout.vue";
import { useAuthStore } from "@/store/auth";
import { useStore } from "@/store";
import { computed } from "vue";

const props = defineProps({
  window: Object
});

const authStore = useAuthStore();
const store = useStore();
const route = useRoute();

const auth = computed(() => store.myData.role);
const nickname = computed(() => store.myData.nickname);
const feedbackUrl = `https://www.notion.so/dnbdivision/449c43ac2607452b85313e1622466666?v=a3855b15bac349cdb07ed6014d6597a6`;

// 언어별 텍스트 헬퍼
const t = (ko, en) => store.userLanguage === 'en' ? en : ko;

// 로그아웃 처리
function logout() {
  const confirmMsg = t("로그아웃 하시겠습니까?", "Are you sure you want to logout?");
  if (!confirm(confirmMsg)) return;
  authStore.logout();
}

// 언어 토글
function handleUserLanguageToggle(lang) {
  store.setUserLanguage(lang);
}
</script>

<template>
  <div class="header">
    <div class="left">
      <h1>
        <router-link to="/projects/list">
          <img src="../assets/img/logo.svg" alt="logo" />
        </router-link>
      </h1>

      <div v-if="authStore.isAuthenticated" class="menu">
        <transition name="fade" mode="out-in">
          <router-link to="/projects/list" :key="store.userLanguage">
            {{ t('프로젝트 리스트', 'Project List') }}
          </router-link>
        </transition>
        <div class="bottom_line" :class="{ 'selected': route.path === '/projects/list' }"></div>
      </div>

      <div v-show="authStore.isAuthenticated && auth === 'ADMIN'" class="menu">
        <transition name="fade" mode="out-in">
          <router-link to="/admin" :key="store.userLanguage">
            {{ t('관리자 페이지', 'Admin Page') }}
          </router-link>
        </transition>
        <div class="bottom_line" :class="{ 'selected': route.path.includes('admin') }"></div>
      </div>

      <div v-show="authStore.isAuthenticated && (auth === 'ADMIN' || store.myData.nickname === '위현복' || store.myData.nickname === '박건규')" class="menu">
        <transition name="fade" mode="out-in">
          <router-link to="/text-editor" :key="store.userLanguage">
            {{ t('법률 번역기', 'Law Translator') }}
          </router-link>
        </transition>
        <div class="bottom_line" :class="{ 'selected': route.path.includes('text-editor') }"></div>
      </div>
    </div>

    <div class="right">
      <!-- 언어 토글 -->
      <div class="user_language_toggle">
        <span class="lang_box" :class="{ active: store.userLanguage === 'ko' }" @click="handleUserLanguageToggle('ko')">KR</span>
        <span class="lang_box" :class="{ active: store.userLanguage === 'en' }" @click="handleUserLanguageToggle('en')">EN</span>
        <div class="active_bg" :class="{ english: store.userLanguage === 'en' }"></div>
      </div>

      <!-- 피드백 링크 -->
      <transition name="fade" mode="out-in">
        <a :href="feedbackUrl" :key="store.userLanguage">{{ t('피드백 리포트', 'Report') }}</a>
      </transition>

      <!-- 로그아웃 및 유저명 표시 -->
      <div v-if="route.path !== '/login' && authStore.userId" class="logout">
        <transition name="fade" mode="out-in">
          <span :key="store.userLanguage">
            {{ store.userLanguage === 'ko' ? `${nickname}님` : `${nickname}` }}
          </span>
        </transition>
        <i-logout class="icon size_12" @click="logout" />
      </div>
    </div>
  </div>
</template>
